import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { useLocation, useParams } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { useNavigate } from 'react-router-dom';
export const AdminViewPatientreport = () => {
    const location = useLocation();
    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);
    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("PatientID") as any);
    }, [location]);

    const { PatientID } = useParams();
    const [patiendata, setPatientdata] = useState<[]>([]);
    const getdata = async () => {
        try {
            const payload = { q: 3, patientid: PatientID };
            const apiname = Admin_API.Apatien_API;
            const data = await LoginService.getData(apiname, payload);
            setPatientdata(data);
        } catch (error) {

        }
    };
    const [casesdata, setCasesdata] = useState<[]>([]);
    const getcases = async () => {
        try {
            const payload = { q: 4, patientid: PatientID };
            const apiname = Admin_API.Apatien_API;
            const data = await LoginService.getData(apiname, payload);
            setCasesdata(data);
        } catch (error) {

        }
    };
    useEffectOnce(() => {
        getdata()
        getcases()
    }, []);
    const navigate = useNavigate();
    const viewPage = (rowData: any) => {
        const url = `/viewcaseslist/${rowData.CaseID}`;
        console.log('rowdata:', rowData.CaseID)
        navigate(url);
    }

    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewadminpatientsreports.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="main-content">
                <div className="content-wrapper">
                    <div className="grid">
                        <div className="col-9">
                            <h2>Doctor Profile</h2>
                        </div>
                        <div className="col-3">
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                    </div>
                    <section className="content">
                        <div className="grid">
                            <div className="col-3">
                                {patiendata.map((response: any) => (
                                    <>
                                        <Card>
                                            <div style={{
                                                height: '150px',
                                                backgroundColor: 'rgb(23, 162, 184)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                                width: '100%'
                                            }}>
                                                <h3 style={{ margin: '0', color: 'white' }}>Patient</h3>

                                                <img
                                                    src={response.photo}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '100px',
                                                        height: '60px',
                                                        borderRadius: '50%',
                                                    }}
                                                />


                                            </div>
                                            <div className="grid">
                                                <div className="col-6">
                                                    <div className="description-block">
                                                        <h5 className="description-header">{response.cases}</h5>
                                                        <span className="description-text">Cases</span>


                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="description-block">
                                                        <h5 className="description-header">{response.appiontments}</h5>
                                                        <span className="description-text">Appiontments</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </Card>

                                    </>
                                ))}
                            </div>
                            <div className='col-9'>
                                <Stepper ref={stepperRef}>
                                    <StepperPanel header="Patient Details">

                                        <Card>
                                            <Panel header="Hospital Name">
                                                <div className="grid">
                                                    {patiendata.map((response: any) => (

                                                        <>
                                                            <div className="col-12 md:col-12 lg:col-6">
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}> Name :</strong>
                                                                    <p className="text-muted">{response.FirstName}{response.LastName}</p>
                                                                </div>


                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Email :</strong>
                                                                    <p className="text-muted">{response.Email}</p>
                                                                </div>

                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Phone No:</strong>
                                                                    <p className="text-muted">{response.Phone}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Skype ID :</strong>
                                                                    <p className="text-muted">{response.SkypeID}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Gender :</strong>
                                                                    <p className="text-muted">{response.Gender}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 md:col-12 lg:col-6">
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Fax.No. :</strong>
                                                                    <p className="text-muted">{response.Fax}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>IDCard No :</strong>
                                                                    <p className="text-muted">{response.IDCardNumber}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Date Of Birth :</strong>
                                                                    <p className="text-muted">{response.DOB}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Status :</strong>
                                                                    <p className="text-muted">{response.Status}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Address :</strong>
                                                                    <p className="text-muted">{response.FirstName}{response.LastName},{response.Street},{response.City},{response.statename},{response.CountryName}</p>
                                                                </div>



                                                                {/* <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                  <strong style={{ marginRight: '10px' }}>Hospital Name :</strong>
                                  <p className="text-muted">{response.hospitalname}</p>
                                </div>

                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                  <strong style={{ marginRight: '10px' }}>Speciality :</strong>
                                  <p className="text-muted">{response.SpecilityName}</p>
                                </div> */}






                                                            </div>
                                                        </>
                                                    ))}
                                                </div>

                                            </Panel>

                                        </Card>
                                    </StepperPanel>
                                    <StepperPanel header="Cases">

                                        <Card>
                                            <Panel header="">

                                                <div className="card card-primary">
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <DataTable value={casesdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                        globalFilterFields={['FirstName', 'CreateDate', 'CaseStatus', 'Status']}>
                                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                        <Column field="FirstName" sortable header="Doctor Name"></Column>
                                                        <Column field="CreateDate" sortable header="Created Date"></Column>
                                                        <Column field="CaseStatus" sortable header="Status"></Column>
                                                        <Column header="Operation" body={(rowData) => (
                                                            <>
                                                                <Button className='mr-1' tooltip="View" severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewPage(rowData)} />

                                                            </>
                                                        )} />

                                                    </DataTable>
                                                </div>
                                            </Panel>


                                        </Card>
                                    </StepperPanel>


                                </Stepper>





                            </div>
                        </div>

                    </section>

                </div>
            </div>



        </div>)
}
